function BasePageTransition() {
	body.imagesLoaded({
		background: true
	}).always(function () {
		pageTransition.enter(function () {
			$(window).trigger('transitionDone');
		});
	});
}

